(() => {
  'use strict';
  const page = document.querySelector('[data-sc-contact-page]');
  if (!page) return;
  const notice = page.querySelector('[data-sc-chat-notice]');
  function reveal(element) {
    element.hidden = false;
    element.focus({ preventScroll: true });
    element.scrollIntoView({ block: 'center', behavior: 'auto' });
  }
  page.querySelectorAll('[data-sc-chat]').forEach(button => {
    button.addEventListener('click', () => {
      if (typeof window.Intercom === 'function') {
        try {
          window.Intercom('showNewMessage');
          notice.hidden = true;
          return;
        } catch (_) {
          // Existing chat may be blocked; keep email and help links available.
        }
      }
      reveal(notice);
    });
  });
  // Submission, CAPTCHA, errors and success are handled by Shopify, without AJAX.
  const result = page.querySelector('[data-sc-result]');
  if (result) reveal(result);
})();
